export const Background = {
  Backdrop: '#F5F6FA',
  Surface: '#FFFFFF',
} as const;

export const Base = {
  Frost: '#F5F6FA',
  Midnight: '#091830',
  White: '#FFFFFF',
  Black: '#000000',
} as const;

export const Content = {
  Hyperlink: '#0B78FF',
  Soft: '#677181',
  Medium: '#445063',
  Hard: Base.Midnight,
} as const;

export const Grey = {
  ExtraSoft: '#EFF0F4',
  Soft: '#CED3DF',
  Medium: '#9EA6BE',
  Hard: '#5D6B93',
} as const;

export const ClarityBlue = {
  ExtraSoft: '#E6F1FF',
  Soft: '#B5D6FF',
  Medium: '#6DAEFF',
  Hard: '#0B78FF',
} as const;

export const ClarityPurple = {
  ExtraSoft: '#E8E3F9',
  Soft: '#D6C4FA',
  Medium: '#AE88F5',
  Hard: '#7839EE',
} as const;

export const ClarityRed = {
  ExtraSoft: '#F2E2E4',
  Soft: '#F4C0BC',
  Medium: '#E7918D',
  Hard: '#D92D20',
} as const;

export const ClarityOrange = {
  ExtraSoft: '#FEF4E6',
  Soft: '#FDDEB5',
  Medium: '#FABC6B',
  Hard: '#F79009',
} as const;

export const ClarityGreen = {
  ExtraSoft: '#E6F4F2',
  Soft: '#B6DEDA',
  Medium: '#6EBEB5',
  Hard: '#0E9384',
} as const;
